export const CONTACT_TAB = 'CONTACT_TAB';
export const DETAILS_TAB = 'DETAILS_TAB';
export const CONVERSATIONS_TAB = 'CONVERSATIONS_TAB';
